import { EventEmitter, } from '@angular/core';
var FolderInfoComponent = /** @class */ (function () {
    function FolderInfoComponent() {
        this.goto = new EventEmitter();
        this.goToMessages = new EventEmitter();
    }
    return FolderInfoComponent;
}());
export { FolderInfoComponent };
